import {Controller} from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['menu', 'toggle'];
    static values = {
        openLabel: String,
        closeLabel: String,
    };

    connect() {
        this.close();
    }

    disconnect() {
        document.body.classList.remove('navigation-open');
    }

    toggle() {
        if (this.menuTarget.hidden) {
            this.open();
            return;
        }

        this.close();
    }

    open() {
        this.menuTarget.hidden = false;
        this.menuTarget.setAttribute('aria-hidden', 'false');
        this.toggleTarget.setAttribute('aria-expanded', 'true');
        this.toggleTarget.setAttribute('aria-label', this.closeLabelValue);
        this.toggleTarget.classList.add('is-open');
        document.body.classList.add('navigation-open');

        this.menuTarget.querySelector('a')?.focus();
    }

    close() {
        this.menuTarget.hidden = true;
        this.menuTarget.setAttribute('aria-hidden', 'true');
        this.toggleTarget.setAttribute('aria-expanded', 'false');
        this.toggleTarget.setAttribute('aria-label', this.openLabelValue);
        this.toggleTarget.classList.remove('is-open');
        document.body.classList.remove('navigation-open');
    }

    closeOnEscape(event) {
        if (event.key !== 'Escape' || this.menuTarget.hidden) {
            return;
        }

        this.close();
        this.toggleTarget.focus();
    }

    closeOnDesktop() {
        if (window.matchMedia('(min-width: 48rem)').matches) {
            this.close();
        }
    }
}
